<section class="container-fluid banner-img d-flex justify-content-center align-items-center">
  <img class="bottomLogo" src="assets/images/white-logo.svg" alt="">
  <div class="row py-5">
    <div class="col-lg-12 col-md-12 col-sm-12 wow bounceInUp">
                <div *ngIf="show" class="card login-card">
                    <div class="card-header login-header" >
                        <img [src]="message.image" class="mb-3"><br>
                        <span class="font-semi-bold">{{message.heading}}</span><br>
                        <p class="font-regular mb-0">{{message.subHeading}}</p>
                    </div>
                    <div class="card-body pt-0">
                        <form class="form"  autocomplete="off">
                              <div class="form-group mt-3">
                                <button type="button" class="form-control submit-btn theme-button" id="btnLogin" [routerLink]="message.link">
                                  <span>{{message.button}}</span>
                                </button>
                              </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    <!-- </div> -->
</section>